export const NavigationThunks = {};
